<template>
  <div>
    <ListForm
      v-if="formType.startsWith('list') && qid != null"
      :query-id="qid"
      :entity-id="entityId"
      :title="title"
      :rows-per-page="rowsPerPage"
      :rows-per-page-items="rowsPerPageItems"
      :default-sort="defaultSort"
      :csv-export="csvExport"
      :date-today="dateToday"
      :form-specs="formSpecs"
    ></ListForm>
    <RaportForm
      v-if="formType.startsWith('raport') && qid != null"
      :query-id="qid"
      :entity-id="entityId"
    ></RaportForm>
    <CrudForm
      v-if="formType === 'crud'"
      :key="$route.fullPath"
      :entity-id="entityId"
      :entry-id="crudEntryId"
      @entryAdded="onAddEntry"
      @entryDeleted="onDeleteEntry"
      @getTitleCrudForm="getTitleCrudForm"
      @destroyedCrudForm="destroyedCrudForm"
    ></CrudForm>
    <CalendarForm
      v-if="formType === 'cal' && calendarQueryId != null"
      :key="$route.fullPath"
      :query-id="calendarQueryId"
    ></CalendarForm>
    <MapForm
      v-if="formType.startsWith('map')"
      :key="$route.fullPath"
      :form-id="formId"
      :query-id="qid"
      :entity-id="entityId"
      @getMapTitle="getMapTitle"
      @destroyedMap="destroyedMap"
    ></MapForm>
    <IFrameForm
      v-if="formType.startsWith('iframe') && formId != null"
      :key="$route.fullPath"
      :form-id="formId"
    ></IFrameForm>
    <ChartForm
      v-if="formType.startsWith('charts') && form != null"
      :key="$route.fullPath"
      :schema="form.schema"
      :entity-id="entityId"
    ></ChartForm>
  </div>
</template>

<script>
import ApiService from '../APIService.js'

export default {
  name: 'FormView',
  components: {
    CrudForm: () => import('./CrudForm.vue'),
    ListForm: () => import('./ListForm.vue'),
    RaportForm: () => import('../leaf_widgets/RaportWidget.vue'),
    CalendarForm: () => import('./CalendarForm.vue'),
    MapForm: () => import('./MapForm.vue'),
    IFrameForm: () => import('./IFrameForm.vue'),
    ChartForm: () => import('./ChartForm.vue')
  },
  props: {
    entityId: {
      type: String,
      required: true
    },
    entryId: {
      // may be parsed instead crudFormInitialValue so FormView will fetch the entry by itself
      type: String,
      default: null
    },
    formType: {
      type: String,
      required: false,
      default: 'crud'
    },
    queryId: {
      type: String,
      default: null
    },
    titleTable: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      formId: null,
      form: null,
      qid: this.queryId,
      calendarQueryId: null,
      routeUpdates: 0,
      defaultSort: null,
      rowsPerPage: null,
      rowsPerPageItems: null,
      csvExport: null,
      title: null,
      emptyFormView: false,
      dateToday: null,
      formSpecs: null
    }
  },
  computed: {
    crudEntryId() {
      return this.entryId != null && this.entryId !== '' ? this.entryId : null
    }
  },
  watch: {
    title: function() {
      this.$emit('getTitleFormView', this.title) //send title up for breadcrumb
    }
  },
  created() {
    var today = new Date()
    let month = today.getMonth() + 1
    let day = today.getDate()
    this.dateToday =
      today.getFullYear() +
      '-' +
      (month < 10 ? '0' + month : month) +
      '-' +
      (day < 10 ? '0' + day : day)

    if (this.entityId == null || this.entityId.trim() === '') {
      console.log('%cNULL ENTITY ID PASSED TO FormView.vue', 'color: #f00')
      return
    }
    if (this.formType.startsWith('list-')) {
      // it's an additional list form
      var additionalListFormId = this.formType.slice(5)

      ApiService.getFormById(additionalListFormId)
        .then((res) => {
          if (res.data.key !== 'list') {
            throw new Error('Invalid form type!')
          }
          this.formSpecs = res.data.specs
          this.qid = res.data.queryId
          this.title = res.data.specs.title
          this.formSpecs = res.data.specs
          this.rowsPerPageItems = res.data.specs.rowsPerPageItems
          this.rowsPerPage = res.data.specs.rowsPerPage
          this.defaultSort = res.data.specs.defaultSort
          this.csvExport = res.data.specs.csvExport
          console.log('Found additional list form: ' + additionalListFormId)
        })
        .catch((err) => {
          console.log(
            'Error fetching additional list form: ' + JSON.stringify(err)
          )
        })
    } else if (this.formType.startsWith('map-')) {
      this.formId = this.formType.slice(4)
      ApiService.getFormById(this.formId)
        .then((res) => {
          this.qid = res.data.queryId
          this.title = res.data.map
          // console.log(`Found query ${this.qid} for form: ${this.formId}`)
        })
        .catch((err) => {
          console.log(
            '%cCould not fetch additional map form ' +
              this.formId +
              ', ex: \n' +
              JSON.stringify(err.response)
          )
        })
    } else if (this.formType.startsWith('iframe-')) {
      this.formId = this.formType.slice('iframe-'.length)
    } else if (this.formType.startsWith('redirect-')) {
      this.formId = this.formType.slice('redirect-'.length)
      ApiService.getFormById(this.formId)
        .then((res) => {
          this.form = res.data
        })
        .catch(() => {
          console.log('Could not fetch redirect form: ' + this.formId)
        })
    } else if (this.formType === 'list' && this.qid == null) {
      // get the query id for the list form
      ApiService.getForm(this.entityId, 'list')
        .then((res) => {
          console.log('Fetched qid: ' + res.data.queryId)
          //console.log(res.data)
          this.qid = res.data.queryId
          this.title = res.data.title
          this.formSpecs = res.data.specs
          if (res.data.specs != null) {
            this.rowsPerPageItems = res.data.specs.rowsPerPageItems
            this.rowsPerPage = res.data.specs.rowsPerPage
            this.defaultSort = res.data.specs.defaultSort
            this.csvExport = res.data.specs.csvExport
          }
        })
        .catch((error) => {
          console.log(
            'Error fetching query id form FormView/ListForm: ' +
              JSON.stringify(error)
          )
        })
    } else if (this.formType === 'raport' && this.qid == null) {
      // get the query id for the raport form
      ApiService.getForm(this.entityId, 'raport')
        .then((res) => {
          if (res.status !== 200) {
            console.log(res.statusText)
          } else {
            this.qid = res.data.queryId
            this.title = res.data.title
          }
        })
        .catch((error) => {
          console.log(
            'Error fetching query id form FormView/ListForm: ' +
              JSON.stringify(error)
          )
        })
    } else if (this.formType === 'charts') {
      ApiService.getForm(this.entityId, 'charts')
        .then((res) => {
          this.form = res.data
        })
        .catch((error) => {
          console.log(
            'Error fetching query id form FormView/ChartsForm: ' +
              JSON.stringify(error)
          )
        })
    } else if (this.formType === 'cal' && this.qid == null) {
      ApiService.getForm(this.entityId, 'cal')
        .then((res) => {
          if (res.status !== 200) {
            console.log(res.statusText)
          } else {
            this.calendarQueryId = res.data.queryId
            this.title = res.data.title
          }
        })
        .catch((error) => {
          console.log(
            'Error fetching query id form FormView/CalendarForm: ' +
              JSON.stringify(error)
          )
        })
    } else {
      this.emptyFormView = true
    }
  },
  destroyed() {
    if (this.emptyFormView) {
      this.$emit('emptyFormView')
    } else {
      this.$emit('destroyedFormView')
    }
  },
  methods: {
    getMapTitle(value) {
      this.$emit('getMapTitle', value)
    },
    getTitleCrudForm(value) {
      this.$emit('getTitleCrudForm', value)
    },
    destroyedCrudForm() {
      this.$emit('destroyedCrudForm')
    },
    destroyedMap() {
      this.$emit('destroyedMap')
    },
    onAddEntry(newEntryId) {
      this.$router.push({
        name: 'UpdateForm',
        params: {
          entityId: this.entityId,
          entryId: newEntryId,
          formType: 'crud'
        }
      })
    },
    onDeleteEntry() {
      this.$router.push({
        name: 'FormView',
        params: {
          entityId: this.entityId,
          formType: 'list'
        }
      })
    }
  }
}
</script>
